import Vuetify from 'vuetify/lib';


export default class UI {


  constructor(Vue, {appConfig, vuetifyConfig}) {
    Vue.use(Vuetify);

    const vuetify = new Vuetify({
      ...vuetifyConfig,

      theme: {
        themes: {
          light: appConfig.colors.themes.light,
          dark: appConfig.colors.themes.dark
        }
      }
    });

    Vue.vuetify = vuetify;

    return vuetify;
  }
}
